import { render, staticRenderFns } from "./MessageConversation.vue?vue&type=template&id=485ea28e&scoped=true"
import script from "./MessageConversation.vue?vue&type=script&lang=js"
export * from "./MessageConversation.vue?vue&type=script&lang=js"
import style0 from "./MessageConversation.vue?vue&type=style&index=0&id=485ea28e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485ea28e",
  null
  
)

export default component.exports